import { fetchSecureData } from "../utils/index";

export const removeSchedule = async (accessToken: string, id: number) => {
  try {
    const data = await fetchSecureData(
      "DELETE",
      `/api/Schedule/Remove?id=${id}`,
      accessToken
    );
    const result = await data.json();
    return result.statusCode;
  } catch (err) {
    // tslint:disable-next-line:no-console
    console.log(`Fetch error for /api/Schedule/Remove?id=${id}`, err);
  }
  return 404;
};

export default removeSchedule;
